export default __webpack_public_path__ + "static/media/video tutorial.f8a86577.svg";